import { Question } from '@app/models/recruiting/question.model';

import { Row } from '@app/components/simple-table/simple-table.component';
import { jobPostingType } from '../meta/question-types';

export const mapQuestionToRow = (question: Question): Row => {
    return {
        cells: [
            question.question,
            jobPostingType[question.atsJobPostingQuestionTypeId],
            question.isRequired ? 'applicant-tracker.required' : 'applicant-tracker.optional',
            question.accessLevelLabel,
        ],
    };
};
